//
import { RTableHeaders } from '@/components/reusable_components/next'

//
export default RTableHeaders
  .from([
    {
      text: 'folio',
      value: 'number',
      width: '8%',
    },
    {
      text: 'folio referencia',
      value: 'referenced_dte_number',
      width: '8%',
    },
    {
      text: 'cliente',
      value: 'sl_customer_business_name',
    },
    {
      text: 'emisión',
      value: 'emission_date',
      align: 'right',
      format: 'date',
    },
    {
      text: 'total',
      value: 'total',
      align: 'right',
      format: 'currency',
    },
  ])

  .set('customer_detail', [
    {
      text: 'sucursal',
      value: 'sl_customer_branch_offices_address',
    },
    {
      text: 'folio',
      value: 'number',
    },
    {
      text: 'folio referencia',
      value: 'referenced_dte_number',
    },
    {
      text: 'emisión',
      value: 'emission_date',
      align: 'right',
      format: 'date',
    },
    {
      text: 'total',
      value: 'total',
      align: 'right',
      format: 'currency',
    },
  ])
